/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Segment_Controls_LabelInputs */

const en_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment controls`)
};

const fr_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de segmentation`)
};

const de_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentsteuerungen`)
};

const it_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlli del segmento`)
};

const ru_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегментные элементы управления`)
};

const es_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de segmento`)
};

const zh_cn2_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`段控件`)
};

const ja_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントコントロール`)
};

const hi_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंड नियंत्रण`)
};

const pt_pt2_segment_event_group_segment_controls_label = /** @type {(inputs: Segment_Event_Group_Segment_Controls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de segmento`)
};

/**
* | output |
* | --- |
* | "Segment controls" |
*
* @param {Segment_Event_Group_Segment_Controls_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_segment_controls_label = /** @type {((inputs?: Segment_Event_Group_Segment_Controls_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Segment_Controls_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_segment_controls_label(inputs)
	if (locale === "de") return de_segment_event_group_segment_controls_label(inputs)
	if (locale === "it") return it_segment_event_group_segment_controls_label(inputs)
	if (locale === "ru") return ru_segment_event_group_segment_controls_label(inputs)
	if (locale === "es") return es_segment_event_group_segment_controls_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_segment_controls_label(inputs)
	if (locale === "ja") return ja_segment_event_group_segment_controls_label(inputs)
	if (locale === "hi") return hi_segment_event_group_segment_controls_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_segment_controls_label(inputs)
	return en_segment_event_group_segment_controls_label(inputs)
});